export enum PRODUCT_FILTER_KEYS {
  colors = 'colors',
  sizes = 'sizes',
  prices = 'prices',
  materials = 'materials',
  constructions = 'constructions',
  styles = 'styles',
  fabrics = 'fabrics',
  category_sweater = 'category_sweater',
  categories = 'categories',
  departments = 'departments',
  stone_shapes = 'stone_shapes',
  diamond_types = 'diamond_types',
}

export enum PRODUCT_SORT_VALUES {
  BEST_SELLER = '  BEST_SELLER',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST',
  ALPHABETICALLY_Z_TO_A = 'ALPHABETICALLY_Z_TO_A',
  ALPHABETICALLY_A_TO_Z = 'ALPHABETICALLY_A_TO_Z',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  FEATURED = 'FEATURED',
  CLP = 'CLP',
  REVENUE = 'REVENUE',
  CLP_RANK = 'CLP_RANK',
  ADJ_REVENUE = 'ADJ_REVENUE',
  CLP_V2_7 = 'CLP_V2_7',
}
